import { usePermissions } from '@/shared/features/ability/hooks/use-permissions/use-permissions';
import { useFeatureFlag } from '@/shared/hooks/use-feature-flag/use-feature-flag';
import { FEATURE_VULNERABILITIES } from '@/shared/hooks/use-feature-flag/use-feature-flag.constants';
import { useReadDeviceVulnerabilitySummaryQuery } from '@/shared/redux/api/assets/vulnerabilities/vulnerabilities-api';

export const useVulnerabilityWarning = () => {
  const { isFeatureFlagEnabled } = useFeatureFlag();
  const featureEnabled = isFeatureFlagEnabled(FEATURE_VULNERABILITIES);
  const hasVulnerabilitiesReadPermission = usePermissions({
    action: 'read',
    entity: 'Vulnerabilities',
  });

  const TUseVulnerabilityWarningParams = {
    skip: !featureEnabled || !hasVulnerabilitiesReadPermission,
    pollingInterval: 60_000,
    refetchOnFocus: true,
    refetchOnReconnect: true,
  } as const;

  const { data } = useReadDeviceVulnerabilitySummaryQuery(
    undefined,
    TUseVulnerabilityWarningParams,
  );

  const vulnerabilitiesCount =
    data?.readAllDeviceVulnerabilities?.itemCount ?? 0;
  const affectedDevicesCount = new Set(
    data?.readAllDeviceVulnerabilities?.items.map((item) => item.deviceId) ??
      [],
  ).size;

  return {
    vulnerabilitiesCount,
    affectedDevicesCount,
  };
};
